import { singleton } from 'tsyringe';
import { EventEmitter } from '../EventEmitter';

@singleton()
export class CspConnectionService {
    public readonly connectionStateChanged = EventEmitter.empty();
}
